import React from "react";
import Navbar from "../Navbar";
import { Helmet } from "react-helmet";
import Footer from '../components/Footer';
import CookiesBanner from '../components/CookiesBanner';

function PoliticaPrivacidad() {
  return (
    <>
      <Helmet>
        <title>Política de Privacidad</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
      <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", lineHeight: "1.6",fontSize: "16px" }}>
        <h1>Política de Privacidad</h1>

        <h2>Responsable del tratamiento</h2>
        <ul>
          <li><strong>Nombre completo:</strong> Enrique Martínez Ferrando</li>
          <li><strong>NIF/CIF:</strong> 20165806g</li>
          <li><strong>Dirección Fiscal:</strong> Calle de las Madreselvas 34, 46185 Pobla de Vallbona, Valencia</li>
          <li>
            <strong>Correo electrónico:</strong>{" "}
            <a href="mailto:info@avisamesibaja.com">info@avisamesibaja.com</a>
          </li>
        </ul>

        
        <h2>Finalidades del tratamiento</h2>
        <ul>
          <li>Gestionar tu registro y acceso a la plataforma mediante autenticación por Google (Google Auth).</li>
          <li>Enviar alertas por email cuando bajen de precio los productos que sigues.</li>
          <li>Realizar análisis estadísticos anónimos del uso del sitio web mediante Google Analytics y Microsoft Clarity, solo con tu consentimiento explícito.</li>
          <li>Medir la eficacia de nuestras campañas publicitarias mediante Google Ads, solo con tu consentimiento explícito.</li>
        </ul>

        <h2>Tratamiento de datos sin registro definitivo</h2>
        <p>
          Si introduces tu email para recibir acceso temporal, tratamos tu correo electrónico y la URL proporcionada solo hasta completar el registro. En caso contrario, los datos se eliminarán automáticamente en un plazo máximo de 30 días.
        </p>

        <h2>Datos personales tratados</h2>
        <ul>
          <li>Email proporcionado para registro y autenticación.</li>
          <li>Lista de productos que deseas seguir.</li>
          <li>Fecha y hora del último acceso (para mantenimiento).</li>
          <li>Datos estadísticos anónimos (zona horaria, navegador, etc.) mediante Google Analytics, si aceptas cookies analíticas.</li>
        </ul>

        <h2>Base legal del tratamiento</h2>
        <ul>
          <li><strong>Gestión del registro y suscripción:</strong> Ejecución del contrato (Art. 6.1.b RGPD).</li>
          <li><strong>Envío de alertas por email:</strong> Consentimiento explícito (Art. 6.1.a RGPD).</li>
          <li><strong>Análisis estadísticos (Google Analytics y Microsoft Clarity):</strong> Consentimiento explícito (Art. 6.1.a RGPD).</li>
          <li><strong>Medición publicitaria (Google Ads):</strong> Consentimiento explícito (Art. 6.1.a RGPD).</li>
        </ul>

        <h2>Destinatarios y transferencias internacionales</h2>
        <p>No cedemos datos personales a terceros, salvo obligación legal. Trabajamos con proveedores externos:</p>
        <ul>
          <li>
            <strong>Firebase (Google LLC):</strong> alojamiento y autenticación. Transferencia internacional a EE.UU. bajo Cláusulas Contractuales Tipo.
          </li>
          <li>
            <strong>Google Analytics (Google LLC):</strong> analítica web anónima mediante cookies. Transferencia internacional bajo Cláusulas Contractuales Tipo.
          </li>
          <li>
            <strong>Microsoft Clarity (Microsoft Corporation):</strong> análisis de comportamiento de usuarios mediante grabaciones de sesión y mapas de calor. Transferencia internacional a EE.UU. bajo Cláusulas Contractuales Tipo.
          </li>
          <li>
            <strong>Google Ads (Google LLC):</strong> medición de conversiones para atribuir los registros originados en nuestras campañas publicitarias. Transferencia internacional a EE.UU. bajo Cláusulas Contractuales Tipo.
          </li>
        </ul>

        <h2>Plazo de conservación de datos</h2>
        <p>
          Conservamos tus datos mientras mantengas tu cuenta activa o hasta que revoques tu consentimiento. En caso de inactividad superior a 24 meses, tus datos serán eliminados.
        </p>

        <h2>Uso de cookies</h2>
        <p>
          Utilizamos cookies técnicas y, con tu consentimiento, cookies analíticas (Google Analytics). Puedes gestionar tus preferencias desde el banner inicial. Consulta nuestra{" "}
          <a href="/politica-cookies" target="_blank" rel="noopener noreferrer">Política de Cookies</a> para más información.
        </p>

        <h2>Enlaces de afiliado</h2>
        <p>
          Esta web incluye enlaces afiliados de Amazon.es. Las compras mediante estos enlaces podrían generar una comisión sin coste adicional para ti, conforme al artículo 22.2 de la LSSI.
        </p>

        <h2>Comunicaciones comerciales</h2>
        <p>
          No enviamos comunicaciones comerciales sin tu consentimiento expreso. Si en el futuro realizamos campañas promocionales, solicitaremos previamente tu autorización.
        </p>

        <h2>Tus derechos</h2>
        <p>
          Puedes ejercer tus derechos (acceso, rectificación, supresión, oposición, limitación y portabilidad) enviando un email a{" "}
          <a href="mailto:info@avisamesibaja.com">info@avisamesibaja.com</a>. También puedes reclamar ante la{" "}
          <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">Agencia Española de Protección de Datos</a>.
        </p>

        <h2>Medidas de seguridad</h2>
        <p>
          Aplicamos medidas técnicas y organizativas adecuadas (cifrado SSL/TLS, control de accesos y auditoría regular) para garantizar la seguridad de tus datos.
        </p>

        <h2>Decisiones automatizadas</h2>
        <p>No realizamos decisiones automatizadas ni elaboración de perfiles.</p>

        <h2>Eliminación de datos</h2>
        <p>
          Puedes solicitar la eliminación de tus datos en cualquier momento desde tu perfil o enviando un email a{" "}
          <a href="mailto:info@avisamesibaja.com">info@avisamesibaja.com</a>.
        </p>

        <h2>Ámbito territorial</h2>
        <p>
          Nuestro servicio está orientado exclusivamente a residentes en España. No garantizamos el cumplimiento normativo fuera del territorio español.
        </p>
      </div>
      <Footer />
      <CookiesBanner />
    </>
  );
}

export default PoliticaPrivacidad;
